import StandardTabPanel from "../../../../ui library/components/tab-panels/standard/StandardTabPanel";

export default function Navigation({ _case, activeTab, children }) {
  const allTabs = [
    {
      key: "details",
      name: "Client Info",
      isDisabled: false,
      permission: null,
      href: `/medical-records/cases/${_case.id}/details`,
    },
    {
      key: "providers",
      name: "Providers",
      isDisabled: false,
      permission: null,
      href: `/medical-records/cases/${_case.id}/providers`,
    },
    {
      key: "appointments",
      name: "Appointments",
      isDisabled: false,
      permission: null,
      href: `/medical-records/cases/${_case.id}/appointments`,
    },
    {
      key: "documents",
      name: "Documents",
      isDisabled: false,
      permission: null,
      href: `/medical-records/cases/${_case.id}/documents`,
    },
  ];

  return (
    <StandardTabPanel activeTab={activeTab} tabList={allTabs}>
      {children}
    </StandardTabPanel>
  );
}
